export default "__VITE_ASSET__DkZ56FTI__"